<template>
  <div style="position: relative">
    <v-expand-transition>
      <div
        v-if="show"
        class="v-tooltip__content d-flex transition-fast-in-fast-out overlay-container"
      >
        <ul>
          <li v-for="(innerList, i) in list" :key="i">
            {{ innerList[0] }}
            <ul v-if="innerList.length > 1">
              <li v-for="(item, j) in innerList.slice(1)" :key="j">
                {{ item }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.overlay-container {
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 16px;
  right: 0;
  width: 40vw;
  min-width: 320px;
  max-width: 600px;
  z-index: 1000;
  padding: 16px;
}
</style>
